module.exports = __webpack_public_path__ + "img/m2.e0def62a.jpg";